/**
 * Environment type definition for upCaret applications.
 */
export type Environment = 'production' | 'staging' | 'development' | 'test';

/**
 * Environment constants for type-safe comparisons.
 * Use these instead of string literals to avoid typos and enable IDE autocomplete.
 */
export const ENV = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
  TEST: 'test',
} as const satisfies Record<string, Environment>;

/**
 * Normalize environment string to lowercase and map common aliases.
 * This is the core logic shared between Node.js and browser implementations.
 */
export function normalizeEnv(env: string): Environment {
  const normalized = env.toLowerCase().trim();

  // Map common aliases
  if (normalized === 'prod') return ENV.PRODUCTION;
  if (normalized === 'dev') return ENV.DEVELOPMENT;
  if (normalized === 'stage') return ENV.STAGING;

  // Return as-is if it's a valid environment
  if (
    normalized === ENV.PRODUCTION ||
    normalized === ENV.STAGING ||
    normalized === ENV.DEVELOPMENT ||
    normalized === ENV.TEST
  ) {
    return normalized as Environment;
  }

  // Default to development for unknown values
  return ENV.DEVELOPMENT;
}
